(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mg-pajama-pair"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mg-pajama-pair')) {
    customElements.define('mg-pajama-pair', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.choices = Array.from(this.querySelectorAll('.mg-pair__select'));
        this.button = this.querySelector('.mg-pair__submit');
        this.buttonText = this.button.textContent;
        this.total = this.querySelector('output');
        this.status = this.querySelector('.mg-pair__status');
        this.review = this.querySelector('.mg-pair__review');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD', currencyDisplay: 'code' });
        this.choices.forEach(choice => {
          choice.disabled = false;
          choice.addEventListener('change', () => this.updateTotal());
        });
        this.button.disabled = false;
        this.updateTotal();
        this.form.addEventListener('submit', event => this.addPair(event));
        this.querySelector('.mg-pair__guide-link').addEventListener('click', () => {
          this.querySelector('details').open = true;
        });
        window.addEventListener('pageshow', () => {
          this.lock(false);
          this.updateTotal();
        });
      }
      updateTotal() {
        const selected = this.choices.map(choice => choice.selectedOptions[0]);
        const complete = selected.every(option => option && option.value && !option.disabled);
        this.total.textContent = complete ? this.money.format(selected.reduce((sum, option) => sum + Number(option.dataset.price), 0) / 100) : this.dataset.pending;
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        this.review.hidden = true;
      }
      lock(busy) {
        this.busy = busy;
        this.button.disabled = busy;
        this.choices.forEach(choice => { choice.disabled = busy; });
        this.form.setAttribute('aria-busy', String(busy));
        this.button.textContent = busy ? this.dataset.adding : this.buttonText;
      }
      async addPair(event) {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const counts = new Map();
        this.choices.forEach(choice => counts.set(choice.value, (counts.get(choice.value) || 0) + 1));
        const items = Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
        this.lock(true);
        this.status.removeAttribute('data-error');
        this.status.textContent = this.dataset.adding;
        this.review.hidden = true;
        try {
          const response = await fetch(this.form.action + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) {
            const message = typeof result.description === 'string' ? result.description : this.dataset.error;
            const problem = new Error(message);
            problem.userFacing = true;
            throw problem;
          }
          this.status.textContent = this.dataset.added;
          window.location.assign(this.form.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = error.userFacing ? error.message : this.dataset.error;
          this.status.setAttribute('data-error', '');
          this.review.hidden = false;
          this.lock(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
